module.exports = __webpack_public_path__ + "img/f_f_business_53_s512_f_business_53_0nbg.361ed844.png";